module.exports = __webpack_public_path__ + "static/media/expImgBlack.1e0aed59.svg";